export default __webpack_public_path__ + "static/media/login.9cfd6d29.wav";